import React, { useState } from 'react';
import styled from 'astroturf/react';

import { Props as SubtopicProps } from './SubtopicSection';

type SubTopicItem = Omit<SubtopicProps, 'courses'>;

export interface Props {
  subtopics: Array<SubTopicItem>;
}

const Bar = styled.div`
  display: flex;
  overflow-x: auto;
  font-size: 16px;

  a:first-child {
    margin-left: auto;
  }

  a:last-child {
    margin-right: auto;
  }
`;

const SubTopic = styled.div<{ selected?: boolean }>`
  padding: 4px 16px;
  font-weight: 500;
  color: #6b6b82;
  border-bottom: 1px solid #dddde2;

  &.selected {
    border-bottom: 2px solid #0645b1;
  }

  &:hover,
  &.selected {
    color: #323338;
  }
`;

const SubtopicsBar: React.FunctionComponent<Props> = ({ subtopics }) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const subTopicElements = subtopics.map(({ name, id }, index) => (
    <a
      key={id}
      style={{ flexShrink: 0 }}
      onClick={() => setSelectedIndex(index)}
      href={'#' + id}
    >
      <SubTopic selected={index === selectedIndex}>{name}</SubTopic>
    </a>
  ));

  return <Bar>{subTopicElements}</Bar>;
};

export default SubtopicsBar;
